'use client';

import { useEffect } from 'react';
import { api } from '@/lib/api';

export function FaviconSync() {
    useEffect(() => {
        api.getSiteConfig().then(config => {
            if (!config.favicon_path) return;
            let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = config.favicon_path;
        }).catch(() => {});
    }, []);

    return null;
}
